import React, { Component } from "react";
import { Link } from "react-router-dom";

import moment from "moment";
import { connect } from "react-redux";
import { APP_VERSION } from "constants/version";

class Footer extends Component {
  render() {
    return (
      <footer className="page-footer">
        <small>©{moment().year()} Construction Lavigne & Baril</small>
        <small>
          Réalisé par{" "}
          <a href="//04h11.com" target="_blank">
            04h11
          </a>
        </small>
      </footer>
    );
  }
}

export default Footer;
